import './AdditionalFiltersModal.css'
import { useAtom } from 'jotai';
import { useFilteredMarket, useFilteredMinSquare, useFilteredMaxSquare, useFilteredMaxPrice, useFilteredMinPrice, useShowPopUpModal, useModalVersion, useModalInfo, useExperienceFilter, usePriceFilter, useCurrencyFilter } from '../../../../data/GlobalStates';
import CloseModal from '../../CommonFunctions/closeModal';

const AdditionalFiltersModal = () => {


    //stany globalne:
    const [ ShowPopUpModal, setShowPopUpModal] = useAtom(useShowPopUpModal);
    const [ ModalVersion, setModalVersion] = useAtom(useModalVersion);
    const [ ModalInfo, setModalInfo] = useAtom(useModalInfo);
    const [ ExperienceFilter, setExperienceFilter ] = useAtom(useExperienceFilter);
    const [ PriceFilter, setPriceFilter ] = useAtom(usePriceFilter);
    const [ CurrencyFilter, setCurrencyFilter ] = useAtom(useCurrencyFilter);
    const [ FilteredMinPrice, setFilteredMinPrice ] = useAtom(useFilteredMinPrice);
    const [ FilteredMaxPrice, setFilteredMaxPrice ] = useAtom(useFilteredMaxPrice);
    const [ FilteredMinSquare, setFilteredMinSquare ] = useAtom(useFilteredMinSquare);
    const [ FilteredMaxSquare, setFilteredMaxSquare ] = useAtom(useFilteredMaxSquare);
    const [ FilteredMarket, setFilteredMarket ] = useAtom(useFilteredMarket);

    const setExperienceLevel = (val) => {
       setExperienceFilter(val)
    };

    const switchPriceFilter = () => {
      setPriceFilter(!PriceFilter)
    };


    const clearFilters = () => {
      setPriceFilter(false)
      setFilteredMinPrice('')
      setFilteredMaxPrice('')
      setFilteredMinSquare('')
      setFilteredMaxSquare('')
      setFilteredMarket('')
    };

 
    const saveSelectedMinPrice = (e) => {
      setFilteredMinPrice (e.target.value)
};

    const saveSelectedMaxPrice = (e) => {
      setFilteredMaxPrice (e.target.value)
};

    const saveSelectedMinSquare = (e) => {
      setFilteredMinSquare (e.target.value)
};

    const saveSelectedMaxSquare = (e) => {
      setFilteredMaxSquare (e.target.value)
};

    const saveSelectedMarket = (e) => {
      setFilteredMarket (e.target.value)
};



const formatNumberWithSpaces = (value) => {
  if (!value) return '';
  return Number(String(value).replace(/\s/g, '')).toLocaleString('pl-PL').replace(/,/g, ' ');
};

    return (
      
       <div>
        <div className='AdditionalFilterContainer'>
           <p className='FilterContainerTitle'>Oferty tylko z podaną ceną:</p>
           <div>
            <button className={PriceFilter ? 'AdditionalFiltersButtonActive' : 'AdditionalFiltersButton'} onClick={switchPriceFilter}>Tak</button>
            <button className={!PriceFilter ? 'AdditionalFiltersButtonActive' : 'AdditionalFiltersButton'} onClick={switchPriceFilter}>Nie</button>
           </div>
         </div>

         <div className='AdditionalFilterContainer'>
           <div className='AdditionalFilterSubContainer'>
             <p className='FilterContainerTitle'>Cena od:</p>
               <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedMinPrice} value={formatNumberWithSpaces(FilteredMinPrice) || ''}></input>
             <p className='FilterContainerTitle'>Cena do:</p>
               <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedMaxPrice} value={formatNumberWithSpaces(FilteredMaxPrice) || ''}></input>
           </div>
         </div>

        <div className='AdditionalFilterContainer'>
           <div className='AdditionalFilterSubContainer'>
             <p className='FilterContainerTitle'>Powierzchnia od:</p>
               <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedMinSquare} value={formatNumberWithSpaces(FilteredMinSquare) || ''}></input>
             <p className='FilterContainerTitle'>Powierzchnia do:</p>
               <input id='TitleInput' className='OfferDetailsInputs' placeholder='' onChange={saveSelectedMaxSquare} value={formatNumberWithSpaces(FilteredMaxSquare) || ''}></input>
           </div>
         </div>

        <div className='AdditionalFiltersConfirmBtnsContainer'>
           <p className='FilterContainerTitle'>Rynek:</p>
              <select name="Experience" id='ExperienceSelect' className='OfferDetailsInputs' onChange={saveSelectedMarket} value={FilteredMarket}>
                <option value='Wybierz'>Wybierz</option>
                <option value='Pierwotny'>Pierwotny</option>
                <option value='Wtórny'>Wtórny</option>
              </select>
         </div>

  
         <div className='AdditionalFiltersConfirmBtnsContainer'>
            <button className='AdditionalFiltersButton' onClick={clearFilters}>Wyczyść Filtry</button>
            <button className='AdditionalFiltersButton' onClick={() => CloseModal(setShowPopUpModal, setModalVersion, setModalInfo)}>Zamknij</button>
         </div>


       </div>
    )
}

export default AdditionalFiltersModal;
